export const sidemenu = {
  account: "Customer Account",
  homes: "Homes",
  users: "Users",
  users2: "Users",
  staff: "Staff",
  employees: "Employees",
  overview: "Overview",
  statistics: "Statistics",
  calendar: "Calendar",
  calendar2: "Calendar",
  awards: "Awards",

  organisation_info: "Organisation info table",
  company_label: "Company",
  company_health: "Health",
  company_hr: "HR",
  company_info:
    "Please select company here Health or HR (you can always switch)!",

  access_level_super_admin: "Super Admin",
  access_level_account_admin: "Account Admin",
  access_level_operations_manager: "Operations Manager",
  access_level_home_manager: "Home Manager",
  logged_in_with: "Logged in with ",
  organisation: " Organisation",
  sub_organisations: " Sub organisation",
  hr_organisation: " Organisation",
  hr_sub_organisations: " Sub organisations",
  hr_employees: "Employees",
  health_organisation: " Customer account",
  health_sub_organisations: " Accommodations",
  health_employees: "Employees",
};
